import { render, staticRenderFns } from "./EnrollEmployeeLoading.vue?vue&type=template&id=2df63e58&scoped=true&"
import script from "./EnrollEmployeeLoading.vue?vue&type=script&lang=js&"
export * from "./EnrollEmployeeLoading.vue?vue&type=script&lang=js&"
import style0 from "./EnrollEmployeeLoading.vue?vue&type=style&index=0&id=2df63e58&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df63e58",
  null
  
)

export default component.exports